import { motion } from "motion/react";
import { useI18n } from "@/i18n/I18nContext";
import { GooglePlayBadgeLink } from "@/landing/components/GooglePlayBadgeLink";
import { GooglePlayQrCode } from "@/landing/components/GooglePlayQrCode";

export function FinalCTASection() {
  const { messages, locale } = useI18n();
  const c = messages.cta;

  return (
    <section className="relative overflow-hidden bg-gradient-to-br from-[#4CAF50] to-[#45a049] py-32 text-white">
      <motion.div
        className="absolute top-0 right-0 h-96 w-96 rounded-full bg-white opacity-5 blur-3xl"
        animate={{
          scale: [1, 1.3, 1],
          x: [0, 50, 0],
          y: [0, 30, 0],
        }}
        transition={{
          duration: 8,
          repeat: Infinity,
          ease: "easeInOut",
        }}
      />

      <div className="relative z-10 container mx-auto px-6 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="mx-auto max-w-4xl text-center"
        >
          <h2 className="mb-6 text-5xl lg:text-7xl">{c.heading}</h2>

          <p className="mx-auto mb-12 max-w-2xl text-xl text-white/90">
            {c.body}
          </p>

          <div className="mb-8 flex flex-col items-center justify-center gap-6 sm:flex-row">
            <motion.div
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="inline-block"
            >
              <GooglePlayBadgeLink
                locale={locale}
                ariaLabel={c.googlePlay}
                className="inline-block rounded-lg shadow-xl outline-none ring-0 transition-opacity hover:opacity-95 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-white"
                imgClassName="h-[60px] w-auto sm:h-16"
              />
            </motion.div>

            <div className="flex flex-col items-center gap-2">
              <GooglePlayQrCode
                ariaLabel={c.scanQr}
                containerClassName="h-32 w-32 rounded-2xl bg-white p-3"
                imgClassName="h-full w-full rounded-xl object-contain"
              />
              <p className="text-sm text-white/80">{c.scanQr}</p>
            </div>
          </div>

          <p className="text-sm text-white/70">{c.tagline}</p>
        </motion.div>
      </div>
    </section>
  );
}
